export default __webpack_public_path__ + "static/media/top-footer-1.c5c71a57.png";